export function isParamEmpty(param) {
    // 判断参数是否为undefined
    if (param == undefined) return true;
    else return /^[\s^0]*$/.test(param);
}
/**
 * 千位一逗
 * 10000 => "10,000"
 */
export function toThousandFilter(num) {
    return (+num || 0)
        .toString()
        .replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));
}

export const simplifyMoney = (money, digit) => {
    const numStr = money.toString();
    const numSplit = numStr.split(".")[0];
    const roundNum = parseInt(money);
    const m = Math.pow(10, digit);
    if (numSplit.length <= 4) {
        // return `${numStr}元`;
        return { value: Number(numStr), unit: '亿元' }
    } else if (numSplit.length > 4 && numSplit.length <= 8) {
        const average = roundNum / 10000;
        const round = parseInt(average * m) / m;
        // return `${round}万元`;
        return { value: Number(round), unit: '万亿' }
    } else {
        const average = roundNum / 100000000;
        const round = parseInt(average * m) / m;
        // return `${round}千万元`;
        return { value: Number(round), unit: '千亿' }
    }
}


export const simplifyMoneyMin = (money, digit) => {
  const numStr = money.toString();
  const numSplit = numStr.split(".")[0];
  const roundNum = parseInt(money);
  const m = Math.pow(10, digit);
  if (numSplit.length <= 4) {
      // return `${numStr}元`;
      return { value: Number(numStr), unit: '万元' }
  } else if (numSplit.length > 4 && numSplit.length <= 8) {
      const average = roundNum / 10000;
      const round = parseInt(average * m) / m;
      // return `${round}万元`;
      return { value: Number(round), unit: '亿元' }
  } else {
      const average = roundNum / 100000000;
      const round = parseInt(average * m) / m;
      // return `${round}千万元`;
      return { value: Number(round), unit: '万亿' }
  }
}
/**
 * 百分数（%） 最大值 100
 */
export function validatePercentage(string) {
    return /^\d\.([1-9]{1,2}|[0-9][1-9])$|^[1-9]\d{0,1}(\.\d{1,2}){0,1}$|^100(\.0{1,2}){0,1}$/.test(
        string
    );
}

/**
 * 最多两位小数
 */
export function validateTwoDecimal(string) {
    return /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(string);
}


/**
 * 保留两位小数
 */
export function keepTwoDecimal(x) {

    var f = parseFloat(x);

    if (isNaN(f)) {

        return false;

    }

    var f = Math.round(x * 100) / 100;

    var s = f.toString();

    var rs = s.indexOf('.');

    if (rs < 0) {

        rs = s.length;

        s += '.';

    }

    while (s.length <= rs + 2) {

        s += '0';

    }

    return s;

};

export function TimeToDate(data) {
    if (data) {
        if (data.length == 8) {
            return data.substring(0, 4) + '-' + data.substring(4, 6) + '-' + data.substring(6, 8)
        } else {
            return data
        }
    } else {
        return ''
    }
};
export function dateFormat(string) {
    return string.replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3");
}



// WEBPACK FOOTER //
// ./src/filters/index.js